interface Props {
  href?: string;
}
const TikTokEmbed = ({ href }: Props) => {
  const id = href?.match(/\/([0-9]{6,})/);
  if (!id) return null;
  return (
    <span className="relative flex justify-center inline-block">
      <iframe
        src={`https://www.tiktok.com/embed/${id[1]}`}
        scrolling="no"
        allow="encrypted-media"
        className="min-w-[325px] max-w-[625px] aspect-[325/739]"
      ></iframe>
    </span>
  );
};

export default TikTokEmbed;
